import { Component, OnInit, Input } from '@angular/core';
import { ApiV1Job, BadgeContent } from '@bluecrew/crew-member-backend-angular-client';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { NavController } from '@ionic/angular';
import { normalizeActiveDaysFromApiV1 } from '../../util/format-utils';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { Dayjs } from 'dayjs';
import { getWageRange, getStartRange } from 'src/app/util/job-util';
import { AnalyticsPlugin } from '@plugins/analytics/analytics-plugin';

@Component({
  selector: 'app-job-info-card',
  templateUrl: './job-info-card.component.html',
  styleUrls: ['./job-info-card.component.scss'],
})
export class JobInfoCardComponent implements OnInit {

  // Badges to be shown on job-info-cards and boolean representing if they should use their included styling
  private readonly badgesToShowAndUseStyling = new Map<BadgeContent.BadgeTypeEnum, boolean>([
    ['directInvite', true],
    ['startingSoon', false],
    ['justPosted', false],
    ['covidPolicy', false]
  ]);

  @Input() jobOrBlueshift: ApiV1Job[];
  @Input() segmentIdentifier: string;
  @Input() analyticsIdentifier: string;
  @Input() isCarouselCard: boolean = false;
  @Input() isSingleCarouselCard: boolean = false;
  @Input() isTopJobsCard: boolean = false;

  job: ApiV1Job;
  isBlueshift: boolean = false;
  isSingleShift: boolean = false;
  blueshiftWageRange: [number, number];
  blueshiftStartRange: [Dayjs, Dayjs];

  constructor(
    private readonly segmentCMOS: SegmentCMOSService,
    private readonly navCtrl: NavController,
  ) {}

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges() {
    this.loadData();
  }

  private loadData() {
    // Either actual single job, or representative job for Blueshift
    this.job = this.jobOrBlueshift[0];
    if (this.job.blueshiftRequestId) {
      this.blueshiftWageRange = getWageRange(this.jobOrBlueshift);
      this.blueshiftStartRange = getStartRange(this.jobOrBlueshift);
      this.isBlueshift = true;
      this.isSingleShift = this.jobOrBlueshift.length === 1;
    } else {
      this.isBlueshift = false;
      this.isSingleShift = this.job.shiftsCount === 1;
    }
  }

  getActiveDays(workdays: boolean[]) {
    return normalizeActiveDaysFromApiV1(workdays);
  }

  getJobWageComponents(wage: number) {
    return wage.toFixed(2).split('.');
  }

  getDistanceInMiles(distanceInMeters: number) {
    const distance = distanceInMeters*0.000621371192;
    return distance.toFixed(1);
  }

  shouldShowBadge(badge: BadgeContent) {
    if (this.badgesToShowAndUseStyling.get(badge.badgeType) !== undefined) {
      return true;
    }
    return false;
  }

  shouldDisplayWageRange(): boolean {
    if (this.isBlueshift) {
      return this.blueshiftWageRange[0] !== this.blueshiftWageRange[1];
    } else {
      return false;
    }
  }

  async onJobClick() {
    this.segmentCMOS.addEvent(`viewJobDetails_from_${this.segmentIdentifier}`, { jobId: this.job?.legacyExternalJobId })
    this.segmentCMOS.addEvent(`viewJobDetails`, { jobId: this.job?.legacyExternalJobId, segmentIdentifier: `${this.segmentIdentifier}` })
    AnalyticsPlugin.logEvent({
      name: `${this.analyticsIdentifier}_open_jobdetail`,
      params: {
        jobId: this.job.legacyExternalJobId
      },
    })
    this.navCtrl.navigateForward(AppRoutingUtil.getPositionJobRoute(this.job.legacyExternalJobId));
  }
}
